import React from 'react';
import { Row, Col, Form, FormGroup, Input, Button, Label } from 'reactstrap';

import Body from '../Components/layout/Body';
import LoginNotice from './LoginNotice';
import LearnMoreModal from '../Components/layout/LearnMoreModal';

const UPDATE_HELP = `
<div>
  <p>Here is where you can change the info for your practitioner account.</p>
  <p>The Email address allows you to receive a password reset in the future, if you need one. You can also use this email address instead of your username when you login, if you prefer.</p>
  <p>The Preferred Name is just a short name for you - it gets displayed in the upper right corner when you are logged in. Many people use their first name for this, but you can enter anything you'd like.
   If you leave the Preferred Name blank, Access Nav will just show 'you' in the upper right.</p>
  <p>There's also a button here to let you change your password.</p>
  <p>Hit Continue to save the changes.</p>
  <p><strong>Note: </strong> currently you cannot change your account username.</p>
</div>
`;

//content sub-component with unique content for this page
function UsersUpdateContent(props) {
  const {
    loggedIn,
    username,
    alias,
    pronoun, 
    email,
    onChangeAlias,
    onChangePronoun,
    onChangeEmail,
    emailValid,
    goToUpdateCredentials
  } = props;
  
  const pronounsLegend = `Pronouns`;
  const pronounsId = "pronouns";
  const pronounsBtns = [
    {
      value: 'they',
      label: `They / Them`,
      moreInfo: ''
    },
    {
      value: 'he',
      label: `He / Him`,
      moreInfo: ''
    },
    {
      value: 'she',
      label: `She / Her`,
      moreInfo: ''
    }

  ];

  /* the email || '' avoids a warning during automated test run App.test.js, for changing component from uncontrolled to controlled.
  https://stackoverflow.com/questions/47012169/a-component-is-changing-an-uncontrolled-input-of-type-text-to-be-controlled-erro
  */
  return(
    <>
    <p>Info for the account with <strong>Username:</strong> {username || '<none>'}</p>
    {!loggedIn && <LoginNotice message="To update account info, you first need to " />}
    <Row className="aa-review-row">
      <Col>
        <Form>
          <FormGroup>
            <Label for="email" className='aa-bold-text'>
              Email
            </Label>
            {' '}
            <LearnMoreModal buttonClassName="aa-no-padding aa-secondary-link" linkText="" 
            title="Why we ask for your email" content="Providing your email address is optional, but it allows you to receive a new password in the future, if you happen to forget it. You can also use your email address instead of your username when you login."/>
            <Input
              id="email"
              value={email || ''}
              onChange={onChangeEmail}
              name="email"
              type="email"
              valid={emailValid === 2}
              invalid={emailValid === 1}
              disabled={!loggedIn}
            />
          </FormGroup>
          <FormGroup>
            <Label for="alias" className='aa-bold-text'>
              Preferred Name <span className="aa-more-info">(what you want to be called, like 'Emily')</span>
            </Label>
            <Input
              id="alias"
              value={alias}
              onChange={onChangeAlias}
              name="alias"
              type="textfield"
              disabled={!loggedIn}
            />
          </FormGroup>
          {/* <FormGroup tag="fieldset" key={pronounsId}>
            <legend>{pronounsLegend}</legend>
            {pronounsBtns.map((btn, index) =>
              <FormGroup check key={index}>
                <Input
                  id={pronounsId+btn.value}
                  value={btn.value}
                  checked={pronoun===btn.value}
                  onChange={onChangePronoun}
                  name={pronounsId}
                  type="radio"
                />
                {' '}
                <Label for={pronounsId+btn.value} check>
                  {btn.label}
                  {' '}
                </Label>
              </FormGroup>
            )}
          </FormGroup> */}
        </Form>
      </Col>
      {/* puts a little margin on the right, for large screen sizes */}
      {/* <div className="col-lg-4"></div> */}
      <Col lg="4"></Col>
    </Row>
    <Row className="aa-review-row">
      <Col>
        <Button color="secondary" disabled={!loggedIn} onClick={goToUpdateCredentials}>
          Change my password
        </Button>
      </Col>
    </Row>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersUpdate(props) {
  const {
    loggedIn,
    username,
    alias,
    pronoun, 
    email,
    onChangeAlias,
    onChangePronoun,
    onChangeEmail,
    emailValid,
    goToUpdateCredentials,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Change Account Info",
    subTitle: "",
    learnMore: {linkText: "Learn More about changing account info",
                title: "Change your account info",
                content: UPDATE_HELP
                },
    nextRoute: '', //EVAL_INTRO, //static name for next page since this never changes
    sidebar: false
  }

  console.log("***rendering UsersUpdate, props: " + JSON.stringify(props));

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersUpdateContent 
          loggedIn={loggedIn}
          username={username}
          alias={alias}
          onChangeAlias={onChangeAlias}
          pronoun={pronoun}
          onChangePronoun={onChangePronoun}
          email={email}
          emailValid={emailValid}
          onChangeEmail={onChangeEmail}
          goToUpdateCredentials={goToUpdateCredentials}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersUpdate;